import { axios_requer, axios_export } from "../axios/http_axios";

// 参数有这些,需要的就填,不写就用默认值

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名

let hasSing = true; //需要签名的加上这个
let method = "GET"; //需要GET请求的加上这个
let headerType = "json"; //需要JSON格式的加上这个

export default {
  async runList(data) {
    let condictions = []
    const params = {}
    if(typeof data === 'string'){
      data = {
        number:data
      }
    }
    params.number = data.number
    for(let key in data){
      if(key === 'number'){
        continue
      }
      if(data[key] === undefined || data[key] === null){
        continue
      }
      condictions.push({
        conditonKey:key,
        conditonVal:data[key]
      })
    }
    if(condictions.length > 0){
      params.conditionReqs = condictions
    }
    return await axios_requer({
      path: "/v1/common/query/runReport",
      params,
      headerType,
    }).then((res) => res.data.result.datas);
  },
  async runDetail(data){
    const res = await this.runList(data)

    return res[0] || {}
  },
  async addLoadOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/addLoadOrder",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async updateLoadOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/updateLoadOrder",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async postingUnloadOrderFinance(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/postingUnloadOrderFinance",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async backPostingUnloadOrderFinance(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/backPostingUnloadOrderFinance",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async cancelLoadOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/cancelLoadOrder",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async saveUnloadOrderFinance(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/saveUnloadOrderFinance",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },

  async addUnLoadOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/addUnLoadOrder",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async updateUnLoadOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/updateUnLoadOrder",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async cancelUnloadOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/cancelUnloadOrder",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async postingDispatchOut(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/postingDispatchOut",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async backPostingDispatchOut(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/backPostingDispatchOut",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async addTransportLine(params) {
    return await axios_requer({
      path: "/admin/v5/tms/transport-line/addTransportLine",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async updateTransportLine(params) {
    return await axios_requer({
      path: "/admin/v5/tms/transport-line/updateTransportLine",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async deleteTransportLines(params) {
    return await axios_requer({
      path: "/admin/v5/tms/transport-line/deleteTransportLines",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  async transportLineDetail(id) {
    return await axios_requer({
      path: "/admin/v5/tms/transport-line/" + id,
      headerType,
      hasSing,
      method,
    }).then((res) => res);
  },

  async getTrackTransportListV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/getTrackTransportList",
      headerType,
      params,
      hasSing,
    }).then((res) => res);
  },
  // 确认签收
  async signforWaybill(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/signforWaybill",
      // path: "/admin/v3/tms/waybill/signforWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async cancelReceiveOrder(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/cancelReceiveOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async cancelStartCar(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/cancelStartCar",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async finishAllTask(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/finishAllTask",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async addBillKfTrackRecordV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/addBillKfTrackRecordV5",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async addSysNotice(params) {
    return await axios_requer({
      path: "/common/v2/sys/notice/addSysNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async updateSysNotice(params) {
    return await axios_requer({
      path: "/common/v2/sys/notice/updateSysNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async sysNoticeDetail(params) {
    return await axios_requer({
      path: "/common/v2/sys/notice/sysNoticeDetail",
      params,
      hasSing,
      method,
    }).then((res) => res);
  },

  async sendSysNotice(params) {
    return await axios_requer({
      path: "/common/v2/sys/notice/sendNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async deleteSysNotice(params) {
    return await axios_requer({
      path: "/common/v2/sys/notice/deleteSysNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async addNotice(params) {
    return await axios_requer({
      path: "/common/v2/notice/draft/addNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async updateNotice(params) {
    return await axios_requer({
      path: "/common/v2/notice/draft/updateNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async sendNotice(params) {
    return await axios_requer({
      path: "/common/v2/notice/draft/sendNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async delNotice(params) {
    return await axios_requer({
      path: "/common/v2/notice/draft/delNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 外发录入前详情(荣祥版)
  async outgoinggetOutgoingBeforeDetailV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/getOutgoingBeforeDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //外发录入(荣祥版)
  async outgoingaddOutgoingBillV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/addOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 外发详情(荣祥版)
  async outgoinggetOutgoingDetailV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/getOutgoingDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //修改外发(荣祥版)
  async outgoingupdateOutgoingBillV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/updateOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量过账
  async outgoingbatchPostingV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/batchPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量过账
  async outgoingbatchBackPostingV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/batchBackPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 调度确认
  async dispatchSureV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/dispatchSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  // 客户档案-新建客户地址
  async addCustomerAddrV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/customer/addCustomerAddr",
      params,
      hasSing,
    }).then((res) => res);
  },
  // 客户档案-修改客户地址
  async udpateCustomerAddrV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/customer/udpateCustomerAddr",
      params,
      hasSing,
    }).then((res) => res);
  },
  async updateWaybillFinance(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/updateWaybillFinance",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async updateWaybillFinanceOther(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/updateWaybillFinanceOther",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async updateWaybillBase(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/updateWaybillBase",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  // 电话通知
  async phoneNoticeV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/delivery/notice/phoneNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async smsNoticeV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/delivery/notice/smsNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async wechatNoticeV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/delivery/notice/wechatNotice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  // 通知记录
  async getDeliveryNoticeRecordV5(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/delivery/notice/getDeliveryNoticeRecord",
      params,
      method,
    }).then((res) => res);
  },

  async editCargoarea(params) {
    return await axios_requer({
      path: "/admin/v5/tms/storage/editCargoarea",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async enableCargoarea(params) {
    return await axios_requer({
      path: "/admin/v5/tms/storage/enableCargoarea",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async delCargoarea(params) {
    return await axios_requer({
      path: "/admin/v5/tms/storage/delCargoarea",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async intoStock(params) {
    return await axios_requer({
      path: "/admin/v5/tms/stock/intoStock",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async outStock(params) {
    return await axios_requer({
      path: "/admin/v5/tms/stock/outStock",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async addStockCargoarea(params) {
    return await axios_requer({
      path: "/admin/v5/tms/stock/addStockCargoarea",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async commandPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/commandPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async fcPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/fcPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async ckPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/ckPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async hkPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/hkPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async shPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/shPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async goods(params){
    if(!params){
      params = {}
    }
    params.number = 'admin_item_list_v5'
    return this.runList(params)
  },

  async district(params){
    if(!params){
      params = {}
    }
    params.number = 'admin_district_list_v5'
    return this.runList(params)
  },

  async loadFcPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/loadFcPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async unLoadFcPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/unLoadFcPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async dispatchLoadFcPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/dispatchLoadFcPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async dispatchUnLoadFcPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/dispatchUnLoadFcPrintData",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async deptTree(params) {
    return await axios_requer({
      path: "/admin/v5/tms/organization/tree",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async defaultDept(params) {
    return await axios_requer({
      path: "/admin/v5/tms/organization/setDefaultDept",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async delException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/delException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async batchAddOutgoing(params) {
    return await axios_requer({
      path: "/admin/v5/tms/outgoing/batchOutgoing",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async receiveOrder(params) {
    return await axios_requer({
      path: "/admin/v5/tms/command/receiveOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async receiveOrderToOutgoing(params) {
    return await axios_requer({
      path: "/admin/v5/tms/command/receiveOrderToOutgoing",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async batchPostingWaybillOtherIn(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/batchPostingWaybillOtherIn",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async batchBackPostingWaybillOtherIn(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/batchBackPostingWaybillOtherIn",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async dispatchWorkers(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/dispatchWorkers/" + params.dispatchId,
      params,
      hasSing,
      headerType,
      method
    }).then((res) => res);
  },

  async addOtherInfo(params) {
    return await axios_requer({
      path: "/admin/v5/tms/dispatch/addOtherInfo",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  async writeOffAll(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/writeOffAll",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async addPaymentAllocationRecord(params) {
    return await axios_requer({
      path: "/admin/v5/finance/allocation/record/addPaymentAllocationRecord",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async updateAllocationRecord(params) {
    return await axios_requer({
      path: "/admin/v5/finance/allocation/record/updateAllocationRecord",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async journalAccountList(params) {
    return await axios_requer({
      path: "/admin/v3/finance/assetaccount/journalAccountList",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async inStockSure(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/inStockSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async inStockCancel(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/inStockCancel",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async approval(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/approval",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async cancelApproval(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/cancelApproval",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async allocationRecordDetail(params) {
    return await axios_requer({
      path: "/admin/v5/finance/allocation/record/detail",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async cancelInSureV5(params) {
    return await axios_requer({
      path: "/admin/v5/finance/allocation/record/cancelInSureV5",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async changeSendWay(params) {
    return await axios_requer({
      path: "/admin/v5/tms/waybill/changeSendWay",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  async getWeiJieDan(params) {
    return await axios_requer({
      path: "/admin/v5/tms/command/wei-jie-dan",
      params,
      hasSing,
      headerType,
      istips:false,
      isShowLoading:false
    }).then((res) => res);
  },
  async getFinanceAllocationRecordPrintData(params) {
    return await axios_requer({
      path: "/admin/v5/finance/allocation/record/getFinanceAllocationRecordPrintData",
      params,
      hasSing,
      headerType,
      istips:false,
      isShowLoading:false
    }).then((res) => res);
  },
  async filesV5(params) {
    return await axios_requer({
      path: "/admin/file/v5/files",
      params,
      hasSing,
      headerType
    }).then((res) => res);
  },
};
